import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { client, urlFor } from '../sanityClient';
import BlockContent from '@sanity/block-content-to-react';

function BlogPost() {
  const [post, setPost] = useState(null);
  const { slug } = useParams();

  useEffect(() => {
    const query = `*[_type == "post" && slug.current == $slug][0]{
      title,
      mainImage,
      publishedAt,
      body
    }`;
    client
      .fetch(query, { slug })
      .then((data) => setPost(data))
      .catch((error) => console.error('Error fetching single post:', error));
  }, [slug]);

  if (!post) {
    return <div style={styles.loading}>Loading post...</div>;
  }

  return (
    <div style={styles.pageContainer}>
      <h1 style={styles.heading}>{post.title}</h1>

      {post.mainImage && (
        <img
          src={urlFor(post.mainImage).width(800).url()}
          alt={post.title}
          style={styles.postImage}
        />
      )}

      <p style={styles.postMeta}>
        Published on{' '}
        <strong>
          {post.publishedAt ? new Date(post.publishedAt).toDateString() : '—'}
        </strong>
      </p>

      {/* Render the "body" field using BlockContent */}
      <div style={styles.postBody}>
        <BlockContent
          blocks={post.body}
          projectId="kptun2pd" // Replace with your Sanity project ID
          dataset="production" // Replace with your Sanity dataset
        />
      </div>
    </div>
  );
}

const styles = {
  loading: { textAlign: 'center', marginTop: '2rem' },
  pageContainer: {
    backgroundColor: '#F4F9F9',
    padding: '2rem',
    minHeight: '70vh',
    maxWidth: '800px',
    margin: '0 auto',
  },
  heading: {
    fontFamily: 'Georgia, serif',
    fontSize: '2rem',
    color: '#34495E',
    marginBottom: '1rem',
  },
  postImage: {
    width: '100%',
    maxHeight: '500px',
    objectFit: 'cover',
    borderRadius: '4px',
    marginBottom: '1rem',
  },
  postMeta: {
    color: '#555',
    fontSize: '0.9rem',
    marginBottom: '1.5rem',
  },
  postBody: {
    lineHeight: '1.6',
    color: '#2C3E50',
    fontSize: '1.1rem',
  },
};

export default BlogPost;
